// src/components/cofounder/InsightsList.js
import React from 'react';
import { Lightbulb } from 'lucide-react';
import InsightCard from './InsightCard';
import { useCoFounder } from '../../context/CoFounderContext';

const InsightsList = ({ onAskAbout, compact = false }) => {
  const { insights, dismissInsight } = useCoFounder();

  if (insights.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center py-8 text-gray-400">
        <Lightbulb size={32} className="mb-2" />
        <p className="text-sm">No insights right now</p>
        <p className="text-xs mt-1">I'll notify you when I spot something important</p>
      </div>
    );
  }

  // Group by priority
  const urgent = insights.filter(i => i.priority === 'urgent');
  const high = insights.filter(i => i.priority === 'high');
  const rest = insights.filter(i => i.priority !== 'urgent' && i.priority !== 'high');

  const renderGroup = (items, label) => {
    if (items.length === 0) return null;
    return (
      <div className="mb-4">
        {!compact && (
          <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-2 px-1">
            {label}
          </h4>
        )}
        <div className="space-y-2">
          {items.map(insight => (
            <InsightCard
              key={insight.id}
              insight={insight}
              onDismiss={dismissInsight}
              onAskAbout={onAskAbout}
              compact={compact}
            />
          ))}
        </div>
      </div>
    );
  };

  return (
    <div className={compact ? 'space-y-1' : 'space-y-2'}>
      {renderGroup(urgent, 'Urgent')}
      {renderGroup(high, 'Important')}
      {renderGroup(rest, 'Other')}
    </div>
  );
};

export default InsightsList;
